module.exports = __webpack_public_path__ + "static/media/kfc.1fff93f6.png";